import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { get } from 'lodash';

import { industry } from '../../utilities/industry';
import RenderSelect from '../../components/RenderSelect';
import RenderField from '../../components/RenderField';
import {
    isDomainValidate,
    notPublicDomain,
    required,
} from '../../utilities/validations';
import { setGetDomainError, getDomainStatus } from '../../store/signup/signupAction';
import { INF_ERROR_CODES } from '../../utilities/constants';
import { lowerCase } from '../../utilities/normalizers';


/**
 * Domain details form
 * @param {*} param0
 */
const DomainDetailsForm = ({
    handleSubmit,
    submit,
    domainPurchaseErrors
}) => {
    /** renders error message */
    const renderError = () => {
        return (
            <p>
                This domain is already registed with InfinCE. Please try another
                domain.
            </p>
        );
    };
    return (
        <form onSubmit={handleSubmit(submit)}>
            <div className="form-group">
                <Field
                    name="businessName"
                    component={RenderField}
                    type="text"
                    placeholder="Business Name"
                    className="form-control"
                    validate={[required]}
                />
            </div>
            <div className="form-group">
                <Field
                    name="businessType"
                    component={RenderSelect}
                    placeholder="Business Type"
                    options={industry}
                    isMulti={true}
                    validate={[required]}
                />
            </div>
            <div className="form-group">
                <Field
                    name="businessDomain"
                    component={RenderField}
                    type="text"
                    placeholder="Business Domain"
                    className="form-control"
                    validate={[required, isDomainValidate, notPublicDomain]}
                    normalize={lowerCase}
                />
            </div>
            <div className="form-group">
                {domainPurchaseErrors ===
                    INF_ERROR_CODES.INF_DOMAIN_REGISTERED && renderError()}
            </div>
        </form>
    );
};

const mapDispatchToProps = {
    setGetDomainError, getDomainStatus
};
const mapStateToProps = (store, props) => ({
    needDomain: get(store, 'signupReducer.needDomain', null),
    stateList: get(store, 'signupReducer.stateData.states', []),
    initialValues: props.initialValues,
    onSubmit: props.submit,
    domainPurchaseErrors: get(store, 'signupReducer.domainPurchaseErrors'),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(
    reduxForm({
        form: 'domainDetails', // a unique identifier for this form,
    })(DomainDetailsForm)
);
